import { ENV } from "../utils";
import { apiFetch } from "./httpClient";

export class AcademicCycle {
  async getAcademicCycles() {
    return apiFetch(ENV.API_ROUTES.ACADEMIC_CYCLE, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  /**
   * Fetches a specific academic cycle by id.
   */
  async getAcademicCycle(academicCycleId) {
    return apiFetch(`${ENV.API_ROUTES.ACADEMIC_CYCLE}/${academicCycleId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async createAcademicCycle(data) {
    return apiFetch(ENV.API_ROUTES.ACADEMIC_CYCLE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      expectedStatus: 201,
    });
  }

  async updateAcademicCycle(academicCycleId, data) {
    return apiFetch(`${ENV.API_ROUTES.ACADEMIC_CYCLE}/${academicCycleId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  async startAcademicCycle(academicCycleId) {
    return apiFetch(`${ENV.API_ROUTES.ACADEMIC_CYCLE}/${academicCycleId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status: 2 }),
    });
  }

  async deleteAcademicCycle(academicCycleId) {
    return apiFetch(`${ENV.API_ROUTES.ACADEMIC_CYCLE}/${academicCycleId}`, {
      method: "DELETE",
    });
  }
}
